import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    headerContainer: {
        marginTop: 36
    },
    billTo: {
        marginTop: 20,
        paddingBottom: 3,
        fontFamily: 'Helvetica-Oblique'
    },
  });

  const CompanyInfo = ({company}) => (
    <View style={styles.headerContainer}>
        <Text>Company Name: {company.company}</Text>
        <Text>Address: {company.address}</Text>
    </View>
  );
  
  export default CompanyInfo